import { render, staticRenderFns } from "./Cost-collection.vue?vue&type=template&id=f0573e10&scoped=true&"
import script from "./Cost-collection.vue?vue&type=script&lang=js&"
export * from "./Cost-collection.vue?vue&type=script&lang=js&"
import style0 from "./Cost-collection.vue?vue&type=style&index=0&id=f0573e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0573e10",
  null
  
)

export default component.exports